import { ROUTES_SQUADS, ROUTES_SQUAD_FORM } from '@/constants/routes';

export default {
    path: '/squads',
    name: 'squads-main',
    component: () => import(/*webpackChunkName: 'squads'*/ '@/views/MySquads.vue'),
    children: [
        {
            path: '/squads/overview',
            name: ROUTES_SQUADS,
            component: () => import(/*webpackChunkName: 'squads'*/ '@/components/squads/Squads.vue')
        },
        {
            path: '/squads/form/:squadId?',
            name: ROUTES_SQUAD_FORM,
            component: () => import(/*webpackChunkName: 'squads'*/ '@/components/squads/CreateSquad.vue')
        }
    ]
};
